import { useEffect, useMemo } from 'react';
import { SettingClient } from '../../helpers/client';
import { trackersRunner } from '../trackersRunner';
import { OmnisendTracker } from './omnisendTracker';

export function OmnisendScript(): React.JSX.Element | null {
  const settingsClient: SettingClient = useMemo(() => new SettingClient(), []);

  useEffect(() => {
    // avoid duplicate
    if (document.getElementById('omnisend-launcher')) {
      return;
    }

    settingsClient
      .get()
      .then((settings) => {
        const brandId = settings?.omnisendBrandId;
        if (!brandId) {
          return;
        }

        if (!window.omnisend) {
          window.omnisend = [];
        }

        window.omnisend.push(['brandID', brandId]);
        const script = document.createElement('script');
        script.id = 'omnisend-launcher';
        script.async = true;
        script.src = 'https://omnisnippet1.com/inshop/launcher-v2.js';
        document.head.appendChild(script);

        trackersRunner.register(new OmnisendTracker());
      })
      .catch((exception) => {
        console.error('Not possible to load settings', exception);
      });
  }, [settingsClient]);

  return null;
}
